import React from 'react';
import moment from "moment"

export default class Clock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: moment().format('DD/MM/yyyy, hh:mm:ss A')
        };
    }
    componentDidMount() {
        this.intervalID = setInterval(
            () => this.tick(),
            1000
        );
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
    }
    tick() {
        this.setState({
            time: moment().format('DD/MM/yyyy, hh:mm:ss A')
        });
    }
    render() {
        return (
            <p className="App-clock" style={{ fontSize: 15, alignSelf: 'center' }}>
                {this.state.time}
            </p>
        );
    }
}